import "./Gradient.scss";
import { ReactComponent as GradientDefinition } from "./gradient.svg";

export const Gradient = () => {
  return <GradientDefinition className="gradient" />;
};
